/**
 * Created by Forev on 2017/5/27.
 */
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {MobileLoginComponent} from './mobile-login/mobile-login.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'mobileLogin',
    component: MobileLoginComponent
  },
  {
    path: 'index',
    loadChildren: 'app/home-page/home-page.module#HomePageModule'
  },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  }
];

@NgModule(
  {
    imports: [ RouterModule.forRoot(routes) ],
    exports: [ RouterModule ]
  }
)

export class AppRoutingModule {}



// WEBPACK FOOTER //
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/src/app/app-routing.module.ts